import { useConfigStore } from '@stores'

const getFileUrl = (file: FileItem, projectId: string, rootGuid: string) => {
  const apiURL = new URL(useConfigStore.getState().apiURL)
  const fullUrl = new URL(`/projects/${projectId}/download/files/${rootGuid}/${file.guid}`, apiURL)

  return fullUrl.toString()
}

export default getFileUrl
